import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  BtnPurpleCircle,
  BtnPurpleCircleTransparent,
  BodyMenuChips,
  BodyLink,
  ArrowDropdownButton
} from 'components/common/Elements/Elements';

import classes from './BtnDropCircle.module.scss';

const BtnDropCircle = ({
  icon,
  menuConfig = [],
  body,
  className,
  selectOption,
  transparent = false,
  rightDrop = false,
  arrow = false,
  manyTabs
}) => {
  const [windowVisible, setWindowVisible] = useState(false);

  const node = useRef();
  const buttonList = useRef();

  useEffect(() => {
    if (windowVisible) {
      document.addEventListener('mousedown', handleClick);
      document.addEventListener('keydown', escAndTabFunction);
    }
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', escAndTabFunction);
    };
  }, [windowVisible]);

  const escAndTabFunction = event => {
    if (event.code === 'Escape' || event.code === 'Tab') {
      setWindowVisible(false);
    }
  };

  const handleClick = e => {
    if (
      node.current.contains(e.target) ||
      buttonList.current.contains(e.target)
    ) {
      return;
    }
    setWindowVisible(false);
  };

  const hahdleButton = () => {
    setWindowVisible(!windowVisible);
  };

  return (
    <div className={cn(className ? className : classes.wrapper)}>
      <div ref={buttonList} className={classes.container}>
        <div>
          {transparent ? (
            <BtnPurpleCircleTransparent onClick={hahdleButton} icon={icon} />
          ) : arrow ? (
            <ArrowDropdownButton onClick={hahdleButton} manyTabs={manyTabs} />
          ) : (
            <BtnPurpleCircle onClick={hahdleButton} icon={icon} />
          )}

          {windowVisible && (
            <div
              className={cn(
                classes.windowWrap,
                rightDrop ? classes.windowWrap_right : classes.windowWrap_center
              )}
              ref={node}
              onClick={() => setWindowVisible(false)}
            >
              {menuConfig.length !== 0 && (
                <BodyMenuChips
                  menuConfig={menuConfig}
                  selectOption={selectOption}
                />
              )}
              {body && <BodyLink selectOption={selectOption} />}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

BtnDropCircle.propTypes = {
  icon: PropTypes.string,
  menuConfig: PropTypes.array,
  body: PropTypes.string,
  className: PropTypes.string,
  selectOption: PropTypes.func.isRequired,
  transparent: PropTypes.bool,
  rightDrop: PropTypes.bool,
  arrow: PropTypes.bool,
  manyTabs: PropTypes.bool
};

export default BtnDropCircle;
